import { createSelector } from "@ngrx/store";
import { BannersState } from "./banners.interface";
import {
  GET_BANNERS_SUCCESS,
  REMOVE_BANNER_SUCCESS,
  ADD_BANNER_SUCCESS,
  BannersActions,
} from "./banners.actions";

export const initialState: BannersState = {
  banners: null,
};

export function bannersReducer(
  state: BannersState = initialState,
  action: BannersActions,
): BannersState {
  switch (action.type) {
    case GET_BANNERS_SUCCESS:
      return {
        ...state,
        banners: action.payload,
      };
    case REMOVE_BANNER_SUCCESS:
      return {
        ...state,
        banners: {
          banners: (state.banners?.banners || []).filter(
            (banner) => banner.addonId !== action.payload,
          ),
        },
      };
    case ADD_BANNER_SUCCESS:
      return {
        ...state,
        banners: {
          banners: [...(state.banners?.banners || []), action.payload],
        },
      };
    default: {
      return state;
    }
  }
}

export const getBannersState = (state: { banners: BannersState }) =>
  state.banners;

export const getBannersSelector = createSelector(
  getBannersState,
  (state: BannersState) => state.banners,
);
